// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__h5QB8","modal":"Modal_modal__Ta7kv","slide-down":"Modal_slide-down__0tnLi"};